import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

interface ToastDescriptionProps extends HTMLAttributes<HTMLParagraphElement> {
  className?: string
}

export function ToastDescription({ className, children, ...props }: ToastDescriptionProps) {
  return (
    <p className={twMerge('text-foreground text-sm font-normal leading-normal', className)} {...props}>
      {children}
    </p>
  )
}
